import React, { useState, useEffect } from "react";
import { isEmpty } from "../libs/isEmpty";
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import AddIcon from '@material-ui/icons/Add';
import FeatureTypeTable from './FeatureTypeTable'
import FeaturetypeModal from './FeaturetypeModal'


import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useCardStyles } from '../styles/commonStyles';


export default function Featuretype({
  ...props
}) {
  const classes = useCardStyles();
  const [isVendorless, setIsVendorless] = useState(true);
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  useEffect(() => {
    if (isEmpty(props.vendorMeta)) {
      setIsVendorless(true);
    } else {
      setIsVendorless(false);
    }
  }, [props.vendorMeta])

  const sources = props.sources;

  return (
    <Card
      className={classes.root}
      raised
    >
      <CardContent>
        <Typography className={classes.title} gutterBottom>
          Featuretypes
        </Typography>
        {isVendorless ? (
          <>
            <ListItem className={classes.listitem} key={"addFeaturetype"}>
              <ListItemText>
                Der er ikke valgt en profil.
              </ ListItemText>
            </ListItem>
          </>
        ) : (
          <>
            {sources.length > 1 ?

              sources.map(function (d, idx) {
                return (
                  <Accordion key={d.ds_id || idx} expanded={expanded === 'panel' + idx} onChange={handleChange('panel' + idx)} >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography gutterBottom className={classes.title}>{d.alias} </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <FeatureTypeTable
                        delete={props.delete}
                        ds_id={d.ds_id}
                        edit={props.edit}
                        featuretypes={props.featuretypes}
                        sources={props.sources}
                        vendorMeta={props.vendorMeta}
                      />
                    </AccordionDetails>
                  </Accordion>
                )
              }) :
              <>
                <Typography gutterBottom className={classes.title}>{sources ? '' : sources[0].alias} </Typography>
                <FeatureTypeTable
                  delete={props.delete}
                  ds_id={sources ? '0' : sources[0].ds_id}
                  edit={props.edit}
                  featuretypes={props.featuretypes}
                  sources={props.sources}
                  vendorMeta={props.vendorMeta}
                />
              </>

            }
            <FeaturetypeModal
              key={"createFeaturetypeModal"}
              btnText={<AddIcon />}
              titleText="Tilføj featuretype"
              values={{}}
              sources={props.sources}
              cancelText="Annuller"
              acceptText="Tilføj"
              acceptAction={props.create}
            />
          </>
        )}

      </CardContent>
    </Card>
  );
}
